import { getToken } from "auth/dataProvider.utils";

export const fetchHtmlContent = url => {
  const requestData = {
    method: "GET",
    mode: "cors",
    headers: {
      "X-Session-Id": getToken(),
      Accept: "text/html",
    },
  };

  return fetch(url, requestData).then(response => {
    if (!response.ok) {
      if (response.status === 401) {
        throw new Error("Unauthorized: Моля, влезте отново.");
      }
      if (response.status === 400) {
        return response.json();
      }
      throw new Error(`Request rejected with status ${response.status}`);
    }

    return response.text();
  });
};
